module.exports = __webpack_public_path__ + "img/login_gsnd.a59cac5d.svg";